/* Desktop/mobile cart controls for the Centrotermico header.
 * Dawn owns cart requests, sections, accessibility and standard events.
 */
(() => {
  let pendingCart = null;

  function updateDesktopCount(count) {
    const container = document.getElementById('cart-icon-bubble-desktop');
    if (!container) return;
    const itemCount = Math.max(0, Number(count) || 0);
    let bubble = container.querySelector('.cart-count-bubble');
    if (!itemCount) {
      bubble?.remove();
    } else {
      if (!bubble) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        container.append(bubble);
      }
      bubble.replaceChildren();
      if (itemCount < 100) {
        const visible = document.createElement('span');
        visible.setAttribute('aria-hidden', 'true');
        visible.textContent = String(itemCount);
        bubble.append(visible);
      }
      const accessible = document.createElement('span');
      accessible.className = 'visually-hidden';
      accessible.textContent = `${itemCount} articoli nel carrello`;
      bubble.append(accessible);
    }
    container.dataset.cartCount = String(itemCount);
  }

  function syncCount() {
    if (pendingCart) return pendingCart;
    pendingCart = fetch(`${routes.cart_url}.js`, { credentials: 'same-origin', cache: 'no-store' })
      .then(response => {
        if (!response.ok) throw new Error('Unable to read cart count');
        return response.json();
      })
      .then(cart => updateDesktopCount(cart.item_count))
      .catch(error => console.error('Centrotermico cart:', error))
      .finally(() => { pendingCart = null; });
    return pendingCart;
  }

  subscribe(PUB_SUB_EVENTS.cartUpdate, ({ cartData } = {}) => {
    if (Number.isFinite(cartData?.item_count)) {
      updateDesktopCount(cartData.item_count);
      return;
    }
    return syncCount();
  });

  // Delegation survives header/section re-renders without duplicate listeners.
  document.addEventListener('click', event => {
    const trigger = event.target.closest('#cart-icon-bubble-desktop');
    const drawer = document.querySelector('cart-drawer');
    if (!trigger || !drawer) return;
    event.preventDefault();
    drawer.open(trigger);
  });
  document.addEventListener('keydown', event => {
    if (event.key !== ' ') return;
    const trigger = event.target.closest('#cart-icon-bubble-desktop');
    const drawer = document.querySelector('cart-drawer');
    if (!trigger || !drawer) return;
    event.preventDefault();
    drawer.open(trigger);
  });
  document.addEventListener('shopify:section:load', syncCount);
})();
